import axios from "axios";
import Swal from "sweetalert2";
import { getServerBaseUrl } from "../utils/portConfig";

// 데이터 호출
export const loadData = async (API_SERVER_URL, token) => {
  try {
    const response = await axios.get(API_SERVER_URL, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      Swal.fire({
        icon: "error",
        title: "데이터 로딩 실패",
        text: "데이터 로딩 실패. 다시 시도해주세요.",
      });
      return [];
    }
  } catch (error) {
    console.error("Error fetching user data:", error);
    if (error.response) {
      const responseData = error.response.data;
      if (responseData) {
        Swal.fire({
          icon: "error",
          title: "데이터 로딩 중 오류 발생",
          text: responseData,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답 오류",
          text: `서버 응답 오류: ${error.response.status}`,
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "서버 응답이 없습니다.",
        text: "서버 응답이 없습니다.",
      });
    }
    return [];
  }
};

// 환자 커뮤니티 게시판-상세 데이터 가져오기(v2)
export const getPatientCommunityDetail = async (API_SERVER_URL, token, postId) => {
  try {
    const response = await axios.get(`${API_SERVER_URL}/community/${postId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (response.status === 200) {
      return response.data.data;
    } else {
      Swal.fire({
        icon: "error",
        title: "게시판 상세데이터 가져오기 실패",
        text: "게시판 상세데이터 가져오기 실패. 다시 시도해주세요.",
      });
      return [];
    }
  } catch (error) {
    console.error("Error get PatientCommunityDetailData:", error);
    if (error.response) {
      const responseData = error.response.data;
      if (responseData) {
        Swal.fire({
          icon: "error",
          title: "데이터 로딩 중 오류 발생",
          text: responseData.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답 오류",
          text: `서버 응답 오류: ${error.response.status}`,
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "서버 응답이 없습니다.",
        text: "서버 응답이 없습니다.",
      });
    }
    return [];
  }
};

// 게시판-상세 데이터

// 게시판-상세 데이터 가져오기
export const getCommunityNoticeDetail = async (API_SERVER_URL, token, noticeDetailData, userId) => {
  try {
    const url = API_SERVER_URL + noticeDetailData.id + "/" + userId;
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      Swal.fire({
        icon: "error",
        title: "게시판 상세데이터 가져오기 실패",
        text: "게시판 상세데이터 가져오기 실패. 다시 시도해주세요.",
      });
      return [];
    }
  } catch (error) {
    console.error("Error get CommunityNoticeDetailData:", error);
    if (error.response) {
      const responseData = error.response.data;
      if (responseData) {
        Swal.fire({
          icon: "error",
          title: "데이터 로딩 중 오류 발생",
          text: JSON.stringify(responseData),
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답 오류",
          text: `서버 응답 오류: ${error.response.status}`,
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "서버 응답이 없습니다.",
        text: "서버 응답이 없습니다.",
      });
    }
    return [];
  }
};

// 유저 상세정보
export const getUserDetail = async (url, token) => {
  try {
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      Swal.fire({
        icon: "error",
        title: "데이터 로딩 실패",
        text: "데이터 로딩 실패. 다시 시도해주세요.",
      });
      return [];
    }
  } catch (error) {
    console.error("Error fetching user data:", error);
    if (error.response) {
      const responseData = error.response.data;
      if (responseData) {
        Swal.fire({
          icon: "error",
          title: "데이터 로딩 중 오류 발생",
          text: responseData,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답 오류",
          text: `서버 응답 오류: ${error.response.status}`,
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "서버 응답이 없습니다.",
        text: "서버 응답이 없습니다.",
      });
    }
    return [];
  }
};

// 사용자 생성 팝업 오픈
export function OpenCreatePopup(setIsPopupOpen, setPopupType) {
  setPopupType("create");
  setIsPopupOpen(true);
}

// 사용자 수정 팝업 오픈
export function OpenModifyPopup(setIsPopupOpen, setPopupType) {
  setPopupType("modify");
  setIsPopupOpen(true);
}

// 팝업 닫기
export function ClosePopup(setIsPopupOpen) {
  setIsPopupOpen(false);
}

// 고시 등록
export function createGosi(API_SERVER_URL, token, userId, gosiData, setIsPopupOpen, setGridReload) {
  axios
    .post(`${API_SERVER_URL}/create/${userId}`, gosiData, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } })
    .then((response) => {
      if (response.status === 201) {
        Swal.fire({
          icon: "success",
          title: "성공",
          text: "고시가 등록되었습니다.",
        }).then(() => {
          setIsPopupOpen(false);
          setGridReload((prev) => !prev);
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "고시 등록 실패. 다시 시도해주세요.",
        });
      }
    })
    .catch((error) => {
      console.error("Error creating gosi:", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "고시 등록 오류",
            text: responseData,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
        });
      }
    });
}

// 공지 등록
export function createNotice(API_SERVER_URL, token, userId, noticeRegFormData, setIsPopupOpen, setGridReload) {
  axios
    .post(`${API_SERVER_URL}/create/${userId}`, noticeRegFormData, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      if (response.status === 201) {
        Swal.fire({
          icon: "success",
          title: "성공",
          text: "공지가 등록되었습니다.",
        }).then(() => {
          setIsPopupOpen(false);
          setGridReload((prev) => !prev);
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "공지 등록 실패. 다시 시도해주세요.",
        });
      }
    })
    .catch((error) => {
      console.error("Error creating Notice:", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "공지 생성 오류",
            text: responseData,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
        });
      }
    });
}

// 유저 생성
export const createUser = async (API_SERVER_URL, token, userId, userData, setIsPopupOpen, setGridReload) => {
  if (userData.profileImg) {
    userData.profileImgId = await uploadFileToS3(token, userData.profileImg);
    delete userData.profileImg;
  }

  if (userData.hospitalId === 0 || userData.hospitalId === "0") {
    userData.hospitalId = null; // 병원 ID가 0인 경우 null로 설정
  }

  try {
    const response = await axios.post(
      `${API_SERVER_URL}/create/${userId}`,
      userData, //formData
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (response.status === 201) {
      Swal.fire({
        icon: "success",
        title: "성공",
        text: "사용자가 생성되었습니다.",
      }).then(() => {
        setIsPopupOpen(false); // 팝업 닫기
        setGridReload((prev) => !prev);
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "실패",
        text: "사용자 생성 실패. 다시 시도해주세요.",
      });
    }
  } catch (error) {
    console.error("Error creating user:", error);
    if (error.response) {
      const responseData = error.response.data;
      if (responseData) {
        Swal.fire({
          icon: "error",
          title: "사용자 생성 오류",
          text: responseData,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답 오류",
          text: `서버 응답 오류: ${error.response.status}`,
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "서버 응답이 없습니다.",
        text: "서버 응답이 없습니다.",
      });
    }
  }
};

// 유저 수정
export const editUser = async (API_SERVER_URL, token, selectedUser, userData, setIsPopupOpen, setGridReload, setSelectedRow) => {
  try {
    if (userData.profileImg) {
      userData.profileImgId = await uploadFileToS3(token, userData.profileImg);
      delete userData.profileImg;
    }

    if (userData.hospitalId === 0 || userData.hospitalId === "0") {
      userData.hospitalId = null; // 병원 ID가 0인 경우 null로 설정
    }

    const response = await axios.put(`${API_SERVER_URL}/${selectedUser.id}/update`, userData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      // Successful user edit
      Swal.fire({
        icon: "success",
        title: "성공",
        text: "사용자가 수정되었습니다.",
      }).then((result) => {
        if (result.isConfirmed) {
          if (setSelectedRow) {
            setSelectedRow(null);
          }
          if (setGridReload) {
            setGridReload((prev) => !prev);
          }
          setIsPopupOpen(false);
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "실패",
        text: "사용자 수정 실패. 다시 시도해주세요.",
      });
    }
  } catch (error) {
    console.error("Error creating user:", error);
    if (error.response) {
      const responseData = error.response.data;
      if (responseData) {
        Swal.fire({
          icon: "error",
          title: "사용자 수정 오류",
          text: responseData,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답 오류",
          text: `서버 응답 오류: ${error.response.status}`,
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "서버 응답이 없습니다.",
        text: "서버 응답이 없습니다.",
      });
    }
  }
};

// v2 유저 수정(patient)
export const editUserV2 = async (API_SERVER_URL, token, editUserData, setIsPopupOpen, refreshGrid, setSelectedRow) => {
  try {
    const response = await axios.patch(`${API_SERVER_URL}/${editUserData.id}`, editUserData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      // Successful user edit
      Swal.fire({
        icon: "success",
        title: "성공",
        text: "사용자가 수정되었습니다.",
      }).then((result) => {
        if (result.isConfirmed) {
          setSelectedRow({}); // 선택된 행 초기화
          refreshGrid();
          setIsPopupOpen(false);
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "실패",
        text: "사용자 수정 실패. 다시 시도해주세요.",
      });
    }
  } catch (error) {
    console.error("Error creating user:", error);
    if (error.response) {
      const responseData = error.response.data;
      if (responseData) {
        Swal.fire({
          icon: "error",
          title: "사용자 수정 오류",
          text: responseData.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답 오류",
          text: `서버 응답 오류: ${error.response.status}`,
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "서버 응답이 없습니다.",
        text: "서버 응답이 없습니다.",
      });
    }
  }
};

// v2 유저 인증수단 삭제
export const deleteOAuthProvider = async (API_SERVER_URL, userId, oauthId, token, refreshGrid, setSelectedRow) => {
  const confirmationResult = await Swal.fire({
    icon: "question",
    title: "인증수단 삭제",
    text: "선택한 인증수단을 삭제하시겠습니까?",
    showCancelButton: true,
    confirmButtonText: "확인",
    cancelButtonText: "취소",
  });

  if (confirmationResult.isConfirmed) {
    try {
      const response = await axios.delete(`${API_SERVER_URL}/${userId}/oauth/${oauthId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        // Successful user edit
        Swal.fire({
          icon: "success",
          title: "성공",
          text: "연결된 인증수단이 삭제되었습니다.",
        }).then((result) => {
          if (result.isConfirmed) {
            setSelectedRow((prev) => ({
              ...prev,
              oauthList: prev.oauthList ? prev.oauthList.filter((oauth) => oauth.id !== oauthId) : [],
            }));
            refreshGrid();
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "인증수단 삭제 실패. 다시 시도해주세요.",
        });
      }
    } catch (error) {
      console.error("Error creating user:", error);
      if (error.response) {
        const responseData = error.response.data;

        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "인증수단 수정 오류",
            text: responseData.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
        });
      }
    }
  }
};

// 병원 생성
export function handleSaveHospitalPopup(API_SERVER_URL, token, userId, hospitalData, setIsPopupOpen, setGridReload) {
  axios
    .post(
      `${API_SERVER_URL}/create/${userId}`,
      {
        hospitalId: hospitalData.hospitalId.trim(),
        hospitalName: hospitalData.hospitalName.trim(),
        hospitalAddress: hospitalData.hospitalAddress.trim(),
        hospitalTelNo: hospitalData.hospitalTelNo,
        hospitalInfo: hospitalData.hospitalInfo.trim(),
        weekdayStartTime: hospitalData.weekdayStartTime,
        weekdayEndTime: hospitalData.weekdayEndTime,
        nightStartTime: hospitalData.nightStartTime,
        nightEndTime: hospitalData.nightEndTime,
        satStartTime: hospitalData.satStartTime,
        satEndTime: hospitalData.satEndTime,
        lunchStartTime: hospitalData.lunchStartTime,
        lunchEndTime: hospitalData.lunchEndTime,
        restDt: hospitalData.restDt,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      if (response.status === 201) {
        Swal.fire({
          icon: "success",
          title: "성공",
          text: "병원 정보가 등록되었습니다.",
        }).then(() => {
          setGridReload((prev) => !prev);
          setIsPopupOpen(false);
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "병원 정보 등록 실패. 다시 시도해주세요.",
        });
      }
    })
    .catch((error) => {
      console.error("Error creating user:", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "병원 정보 등록 오류",
            text: responseData,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
        });
      }
    });
}

// 병원 수정
export const handleEditHospitalPopup = async (API_SERVER_URL, token, userId, hospitalData, setIsPopupOpen, setGridReload, setSelectedRow) => {
  //Ask for confirmation before saving user edits
  const confirmationResult = await Swal.fire({
    icon: "question",
    title: "병원 수정 저장",
    text: "병원 정보를 수정하시겠습니까?",
    showCancelButton: true,
    confirmButtonText: "확인",
    cancelButtonText: "취소",
  });
  if (confirmationResult.isConfirmed) {
    try {
      const response = await axios.put(
        `${API_SERVER_URL}/${hospitalData.id}/update/${userId}`,
        {
          hospitalId: hospitalData.hospitalId.trim(),
          hospitalName: hospitalData.hospitalName.trim(),
          hospitalAddress: hospitalData.hospitalAddress.trim(),
          hospitalTelNo: hospitalData.hospitalTelNo,
          hospitalInfo: hospitalData.hospitalInfo.trim(),
          weekdayStartTime: hospitalData.weekdayStartTime,
          weekdayEndTime: hospitalData.weekdayEndTime,
          nightStartTime: hospitalData.nightStartTime,
          nightEndTime: hospitalData.nightEndTime,
          satStartTime: hospitalData.satStartTime,
          satEndTime: hospitalData.satEndTime,
          lunchStartTime: hospitalData.lunchStartTime,
          lunchEndTime: hospitalData.lunchEndTime,
          restDt: hospitalData.restDt,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "성공",
          text: "병원 정보가 수정되었습니다.",
        }).then((result) => {
          if (result.isConfirmed) {
            setGridReload((prev) => !prev);
            setSelectedRow(null);
            setIsPopupOpen(false);
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "병원 정보 수정 실패. 다시 시도해주세요.",
        });
      }
    } catch (error) {
      console.error("Error creating hospital: ", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "병원 정보 수정 오류",
            text: responseData,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
        });
      }
    }
  }
};

// row 선택 이벤트
export function selectRow(event, setSelectedRow) {
  const selectedRows = event.api.getSelectedRows();
  setSelectedRow(selectedRows.length > 0 ? selectedRows[0] : null);
}

// 병원, 사용자 공통 삭제 함수
export const deleteInfoFunction = async (selectedRow, token, flag, setGridReload, setSelectedRow, setIsPopupOpen) => {
  const id = selectedRow.id;
  let word = "";
  if (flag === "hospital") {
    word = "병원정보";
  } else if (flag === "user") {
    word = "사용자";
  }

  const confirmationResult = await Swal.fire({
    icon: "question",
    title: word + " 삭제",
    text: word + "를 삭제하시겠습니까?",
    showCancelButton: true,
    confirmButtonText: "확인",
    cancelButtonText: "취소",
  });

  if (confirmationResult.isConfirmed) {
    try {
      const response = await axios.delete(selectedRow.links.delete.href, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 204) {
        // Successful deletion
        const successResult = await Swal.fire({
          icon: "success",
          title: "성공",
          text: word + "가 삭제되었습니다.",
          confirmButtonText: "확인",
        });

        if (successResult.isConfirmed) {
          setGridReload((prev) => !prev);
          setSelectedRow(null);
          setIsPopupOpen(false);
        }
      } else {
        await Swal.fire({
          icon: "error",
          title: "실패",
          text: word + " 삭제 실패. 다시 시도해주세요.",
          confirmButtonText: "확인",
        });
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: word + " 삭제 오류",
            text: responseData,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
        });
      }
    }
  }
};

// 병원, 사용자 공통 삭제 함수
export const deleteUserV2 = async (url, userId, token, setIsPopupOpen, refreshGrid, setSelectedRow) => {
  const confirmationResult = await Swal.fire({
    icon: "question",
    title: "계정 탈퇴(삭제)",
    text: "계정을 탈퇴하시겠습니까?",
    showCancelButton: true,
    confirmButtonText: "확인",
    cancelButtonText: "취소",
  });

  if (confirmationResult.isConfirmed) {
    try {
      const response = await axios.delete(`${url}/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        // Successful deletion
        const successResult = await Swal.fire({
          icon: "success",
          title: "성공",
          text: "계정이 탈퇴(삭제)되었습니다.",
          confirmButtonText: "확인",
        });

        if (successResult.isConfirmed) {
          refreshGrid();
          setSelectedRow({}); // 선택된 행 초기화
          setIsPopupOpen(false);
        }
      } else {
        await Swal.fire({
          icon: "error",
          title: "실패",
          text: "계정 삭제 실패. 다시 시도해주세요.",
          confirmButtonText: "확인",
        });
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "계정 삭제 오류",
            text: responseData.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
        });
      }
    }
  }
};

// 고시 삭제
export const deleteGosi = async (API_SERVER_URL, selectedRow, token, setGridReload, setSelectedRow, setIsPopupOpen, setShowGosiPopup) => {
  const id = selectedRow.id;
  const confirmationResult = await Swal.fire({
    icon: "question",
    title: "고시 삭제",
    text: "고시를 삭제하시겠습니까?",
    showCancelButton: true,
    confirmButtonText: "확인",
    cancelButtonText: "취소",
  });

  if (confirmationResult.isConfirmed) {
    try {
      const response = await axios.delete(`${API_SERVER_URL}/${id}/delete`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 204) {
        const successResult = await Swal.fire({
          icon: "success",
          title: "성공",
          text: "고시가 삭제되었습니다.",
          confirmButtonText: "확인",
        });

        if (successResult.isConfirmed) {
          setSelectedRow(null);
          setIsPopupOpen(false);
          setShowGosiPopup(false);
          setGridReload((prev) => !prev);
        }
      } else {
        await Swal.fire({
          icon: "error",
          title: "실패",
          text: "고시 삭제 실패. 다시 시도해주세요.",
          confirmButtonText: "확인",
        });
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "고시 삭제 오류",
            text: responseData,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
        });
      }
    }
  }
};

// 공지 삭제
export const deleteNotice = async (selectedRow, token, setGridReload, setSelectedRow, setIsPopupOpen, setShowNoticePopup) => {
  const confirmationResult = await Swal.fire({
    icon: "question",
    title: "공지 삭제",
    text: "공지를 삭제하시겠습니까?",
    showCancelButton: true,
    confirmButtonText: "확인",
    cancelButtonText: "취소",
  });

  if (confirmationResult.isConfirmed) {
    try {
      const response = await axios.delete(`/api/v1/bbs/${selectedRow.id}/delete`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 204) {
        const successResult = await Swal.fire({
          icon: "success",
          title: "성공",
          text: "공지가 삭제되었습니다.",
          confirmButtonText: "확인",
        });

        if (successResult.isConfirmed) {
          setSelectedRow(null);
          setIsPopupOpen(false);
          setShowNoticePopup(false);
          setGridReload((prev) => !prev);
        }
      } else {
        await Swal.fire({
          icon: "error",
          title: "실패",
          text: "공지 삭제 실패. 다시 시도해주세요.",
          confirmButtonText: "확인",
        });
      }
    } catch (error) {
      console.error("Error deleting Notice: ", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "공지 삭제 오류",
            text: responseData,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
        });
      }
    }
  }
};

// 비밀번호 초기화
export const resetUserPassword = async (API_SERVER_URL, selectedRow, token, userId, setGridReload, setSelectedRow, setIsPopupOpen) => {
  const id = selectedRow.id;

  // 사용자에게 초기화 진행 여부를 묻는 SweetAlert2 모달 표시
  const confirmationResult = await Swal.fire({
    icon: "question",
    title: "비밀번호 초기화",
    text: "비밀번호를 초기화하시겠습니까?",
    showCancelButton: true, // 취소 버튼 추가
    confirmButtonText: "확인", // 확인 버튼 텍스트
    cancelButtonText: "취소", // 취소 버튼 텍스트
  });

  if (confirmationResult.isConfirmed) {
    try {
      const response = await axios.post(
        `${API_SERVER_URL}/${id}/resetPassword/${userId}`,
        null, // You may need to send additional data here if required by your API
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        // 비밀번호 초기화 성공 시 SweetAlert2 모달 표시
        const result = await Swal.fire({
          icon: "success",
          title: "비밀번호 초기화 성공",
          text: "임시비밀번호 : " + response.data,
        });

        if (result.isConfirmed) {
          // 사용자가 확인 버튼을 클릭한 경우
          setGridReload((prev) => !prev); // 그리드 리로드
          setSelectedRow(null); // 선택된 행 초기화
          setIsPopupOpen(false); // Close the popup
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "비밀번호 초기화 실패",
          text: "비밀번호 초기화 실패. 다시 시도해주세요.",
        });
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "비밀번호 초기화 오류",
            text: responseData,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
        });
      }
    }
  }
};

// 파일 미리보기
export const filePreview = async (attachment, token) => {
  let fileUrl = "";
  try {
    const response = await axios.get(attachment.links.download.href, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      // Blob을 사용하여 미리보기 링크 생성
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      fileUrl = url; // 미리보기 URL 저장
    } else {
      Swal.fire({
        icon: "error",
        title: "미리보기 실패",
        text: "파일 미리보기 실패. 다시 시도해주세요.",
      });
    }
  } catch (error) {
    console.error("파일 미리보기 오류:", error);
    if (error.response) {
      const responseData = error.response.data;
      if (responseData) {
        Swal.fire({
          icon: "error",
          title: "파일 미리보기 오류",
          text: responseData,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답 오류",
          text: `서버 응답 오류: ${error.response.status}`,
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "서버 응답이 없습니다.",
        text: "서버 응답이 없습니다.",
      });
    }
  }
};

// 파일 다운로드 처리 함수
export const fileDownload = async (attachment, token) => {
  try {
    const response = await axios.get(attachment.links.download.href, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      // Blob을 사용하여 다운로드 링크 생성
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = attachment.filename;
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      Swal.fire({
        icon: "error",
        title: "다운로드 실패",
        text: "파일 다운로드 실패. 다시 시도해주세요.",
      });
    }
  } catch (error) {
    console.error("파일 다운로드 오류:", error);
    if (error.response) {
      const responseData = error.response.data;
      if (responseData) {
        Swal.fire({
          icon: "error",
          title: "파일 다운로드 오류",
          text: responseData,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답 오류",
          text: `서버 응답 오류: ${error.response.status}`,
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "서버 응답이 없습니다.",
        text: "서버 응답이 없습니다.",
      });
    }
  }
};

//새로고침용 (공지관리)
export const refreshDetails = async (url, token) => {
  try {
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (response.status !== 200) {
      throw new Error("상세 정보를 가져오는 중 오류가 발생했습니다.");
    }
    return response.data;
  } catch (error) {
    console.error("상세 정보 fetch 오류: ", error);
    return null;
  }
};

// S3 파일 업로드 함수
export const uploadFileToS3 = async (token, file) => {
  // 1. presigned URL 요청
  const presignUrl = `${getServerBaseUrl()}/api/v2/s3-attachment/presigned`;
  const meta = {
    originalFilename: file.name,
    contentType: file.type,
    size: file.size,
  };
  try {
    // presigned URL 요청
    const presignRes = await axios.post(presignUrl, meta, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (presignRes.status !== 200 || !presignRes.data?.data?.presignedUrl) {
      throw new Error("Presigned URL 요청 실패");
    }
    const { presignedUrl, id } = presignRes.data.data;

    // 2. presignedUrl로 PUT 업로드
    const putRes = await axios.put(presignedUrl, file, {
      headers: {
        "Content-Type": file.type,
        Authorization: undefined, // 명시적 제거
      },
      withCredentials: false,
    });
    if (!(putRes.status === 200 || putRes.status === 201)) {
      throw new Error("S3 업로드 실패");
    }

    // 3. id 반환
    return id;
  } catch (error) {
    console.error("S3 파일 업로드 오류:", error);
    throw error;
  }
};

// 여러 파일을 압축하여 다운로드하는 함수
// export function downloadZipFiles(attachments, token,fileName) {
//   const zip = new JSZip();
//   attachments.forEach((attachment, index) => {
//     // Blob 형태로 파일 다운로드 링크 생성
//     fetch(attachment.links.download.href, {
//       method: 'GET',
//       headers: {
//         'accept': 'application/octet-stream',
//         'Authorization': `Bearer ${token}`
//       },
//     })
//     .then((response) => response.blob())
//     .then((blob) => {
//       // Blob을 압축 파일에 추가
//       zip.file(attachment.filename, blob);

//       // 모든 파일을 추가한 후에 압축 파일을 생성하고 다운로드
//       if (index === attachments.length - 1) {
//         zip.generateAsync({ type: 'blob' }).then((content) => {
//           // 압축 파일 다운로드
//           FileSaver.saveAs(content, fileName);
//         });
//       }
//     })
//     .catch((error) => {
//       console.error('다운로드 오류:', error);
//     });
//   });
// }
